// import React, { useEffect } from 'react';
import React, { useEffect, useState } from 'react';
import { useDrop, XYCoord } from 'react-dnd'
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { getNextMaxZIndex } from 'redux/layout/reducer';
import { layoutSelector } from 'redux/layout/selectors';
import { styled } from '../../assets/theme';
import { Panel } from '../../components'
import { deleteItem as dispatchDeletedItem, loadLayout as dispatchLoadLayout, updateItem as dispatchUpdateItem, updateLayout as dispatchUpdateLayout } from '../../redux/layout/actions';
import { widgetItems } from './widgetItemsConfig';

export interface IDragItem {
  type: string
  id: string
  top: number
  left: number
}

interface IStateProps {
  currentLayout: any
}

interface IDispatchProps {
  deleteItem: (options: any) => void,
  updateLayout: (layout: any) => void,
  loadLayout: () => void
}

type Props = IStateProps & IDispatchProps

interface IWidgetLayout {
  i: number,
  x: number,
  y: number,
  h: number,
  w: number,
  z: number
  type: string
}


const Dashboard: React.FunctionComponent<Props> = ({ deleteItem, updateLayout, loadLayout, currentLayout }) => {
  const [layouts, setLayouts] = useState<IWidgetLayout[]>([]);

  const handleRemoveWidget = (options: number) => {
    deleteItem(options);
  };


  const [, drop] = useDrop({
    accept: 'box',
    drop(item: IDragItem, monitor) {
      const delta = monitor.getDifferenceFromInitialOffset() as XYCoord
      const left = Math.round(item.left + delta.x)
      const top = Math.round(item.top + delta.y)
      moveBox(item.id, left, top)
      return undefined
    },
  })

  const moveBox = (id: string, left: number, top: number) => {

    updateLayout([{
      i: +id,
      x: (Math.floor(left / 10) * 10),
      y: (Math.floor(top / 10) * 10),
    }])
  }

  useEffect(() => {
    if (currentLayout && currentLayout.table && currentLayout.table.Dashboard && currentLayout.table.Dashboard.grid) {
      const mappedLayouts: IWidgetLayout[] = currentLayout.table.Dashboard.grid.map((item: any) => {
        return {
          h: item.h,
          i: item.key,
          static: false,
          type: item.type,
          w: item.width,
          x: item.x,
          y: item.y,
          z: item.z || 0,
        }
      })
      setLayouts(mappedLayouts);
    }
  }, [currentLayout]);

  useEffect(() => {
    if (loadLayout) {
      loadLayout();
    }
  }, [loadLayout]);

  const zindex = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const id = event.currentTarget.dataset.id
    if (id) {
      updateLayout([{
        i: +id,
        z: getNextMaxZIndex()
      }]);
    }
  }

  if (!currentLayout.initialized) { return <div />; }
  return (
    <DashboardContainer ref={drop} id="dashboard">
      {
        layouts.map((widgetConfig: IWidgetLayout) => {
          if (widgetItems[widgetConfig.type]) {
            const resolvedProps = {};
            widgetItems[widgetConfig.type].configProps.forEach(prop => {
              resolvedProps[prop] = widgetConfig[prop];
            });

            return (
              <div key={widgetConfig.i} data-id={widgetConfig.i} onMouseDown={zindex}>
              <Panel

                id={widgetConfig.i}
                isActive={true}
                width={widgetConfig.w}
                height={widgetConfig.h}
                handleRemoveWidget={handleRemoveWidget}
                title={widgetItems[widgetConfig.type].title}
                phref={widgetItems[widgetConfig.type].phref}
                top={widgetConfig.y}
                left={widgetConfig.x}
                updateLayout={updateLayout}
                zIndex={widgetConfig.z}
                handler='handle'
                {...widgetItems[widgetConfig.type].panelProps}>
                {
                  React.createElement(widgetItems[widgetConfig.type].component, {
                    ...resolvedProps,
                    handleRemoveWidget: widgetItems[widgetConfig.type].panelProps.hideHeader ? handleRemoveWidget : undefined,
                    id: widgetConfig.i,
                    options: widgetConfig,
                  })
                }
              </Panel>
              </div>
            );
          }
          return <div key={Math.random()} />;
        })
      }
    </DashboardContainer>
  );
};


const DashboardContainer = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.core.offBackground};
  color: ${({ theme }) => theme.core.textColor};
  height: 100vh;
  overflow-y: auto;

`;

const mapStateToProps = (state: any) => ({
  currentLayout: layoutSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  deleteItem: (id: number) => dispatch(dispatchDeletedItem({ id })),
  loadLayout: () => dispatch(dispatchLoadLayout()),
  updateItem: (payload: any) => dispatch(dispatchUpdateItem(payload)),
  updateLayout: (payload: any) => dispatch(dispatchUpdateLayout(payload)),
});

export const ConnectedDashboard = connect(mapStateToProps, mapDispatchToProps)(Dashboard)
